import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { get } from "../api.js";
import { navigateToLessonResource } from "../lessonResourceDestination.js";
import { useAsync } from "../useAsync.js";

/** Authentication happens before this page; the server still checks the exact note and family. */
export function LessonResourceOpen() {
  const { pathname } = useLocation();
  const resource = useAsync(async () => {
    const result = await get<{ url: string; title: string }>(pathname, { resolve: "1" });
    if (!/^https?:\/\//i.test(result.url) || !["https:", "http:"].includes(new URL(result.url).protocol)) {
      throw new Error("The file could not be opened. Please try again.");
    }
    return { ...result, path: pathname };
  }, [pathname]);

  useEffect(() => {
    if (!resource.loading && !resource.error && resource.data?.path === pathname) navigateToLessonResource(resource.data.url);
  }, [pathname, resource.loading, resource.error, resource.data]);

  return <main className="signin" id="main-content">
    <div>
      <h1>{resource.error ? "File unavailable" : "Opening lesson resource…"}</h1>
      {resource.error ? <>
        <p>This file may have been removed, or this account may not have access. Sign in with the account that received the lesson note.</p>
        <button type="button" onClick={resource.reload}>Try again</button>
      </> : resource.data?.path === pathname ? <p><a href={resource.data.url}>Open {resource.data.title}</a></p> : <p role="status">Checking access…</p>}
      <p><Link to="/">Back to the Hub</Link></p>
    </div>
  </main>;
}
